type EvidenceErrorItem = Record<string, string>;

export default function buildEvidenceErrorMessage(
  errors: unknown[],
): string | null {
  const invalidFiles: string[] = [];
  const metadataFiles: string[] = [];
  let invalidSuffix =
    "Only .jpg, .jpeg, or .png files are allowed in the uploaded zip file.";

  for (const item of errors) {
    if (!item || typeof item !== "object") {
      continue;
    }

    for (const [fileName, message] of Object.entries(
      item as EvidenceErrorItem,
    )) {
      if (typeof message !== "string") {
        continue;
      }

      if (message.includes("Metadata not found")) {
        metadataFiles.push(fileName);
      }

      if (message.includes("Invalid files detected")) {
        invalidFiles.push(fileName);
        const suffixMatch = message.match(/Only\s.*$/);
        if (suffixMatch?.[0]) {
          invalidSuffix = suffixMatch[0];
        }
      }
    }
  }

  const messages: string[] = [];

  if (invalidFiles.length > 0) {
    messages.push(
      `Invalid files detected: ${invalidFiles.join(", ")}. ${invalidSuffix}`,
    );
  }

  if (metadataFiles.length > 0) {
    messages.push(
      `Metadata not found in the following file(s): ${metadataFiles.join(
        ", ",
      )}. Please upload photo(s) with valid metadata.`,
    );
  }

  return messages.length > 0 ? messages.join("\n") : null;
}
